module.exports = __webpack_public_path__ + "img/dea-formazione-ico-scienze.a8235a36.svg";